<template lang="html">
    <div class="lock-page" v-show="show">
        <h4 :style="hSty"><i class="glyphicon glyphicon-repeat"></i> {{content}}……</h4>
    </div>
</template>
<script>
    export default{
        data: () => ({
            wH: 0,
            show: false,
            content: '正在加载'
        }),
        ready() {
            this.$set('wH', $(window).height());
            this.hSty();
        },
        events: {
            'parent-lock-page-data' (obj){
                this.$set('show', obj.show);
                obj.content && this.$set('content', obj.content);
                setTimeout(()=>{
                    this.$set('show', false);
                },3000);
            }
        },
        methods: {
            hSty() {
                return {
                    marginTop: this.wH/2+8+'px'
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// lockPage.vue?5fc4ac57